<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="支付宝搜索页" />
      <button
        class="hotspot back-arrow"
        type="button"
        aria-label="返回上一页"
        @click="goBack"
      />
      <button
        class="hotspot history-item"
        type="button"
        aria-label="点击电子身份证搜索历史"
        @click="goResult"
      />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-flow-search-no-status.png";

export default {
  name: "AlipayFlowSearch",
  data() {
    return {
      screenImage,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goResult() {
      this.$router.push({ name: "AlipayFlowResult" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}

.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: visible;
  border-radius: 0;
}

.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}

.history-item {
  left: 4.5%;
  top: 11.4%;
  width: 24%;
  height: 5%;
}

.back-arrow {
  left: 1.5%;
  top: 2.2%;
  width: 9%;
  height: 6%;
}
</style>
